import {
  camelCaseObjectKeys,
  snakeCaseObjectKeys,
} from '@doordash/object-utils'
import axios from 'axios'
import { bffOpts } from './config'

export interface SubmitNccCheckResponse {
  continueUrl: string
}

export interface SubmitNccCheckRequest {
  applicantUniqueLink: string
}

/**
 * Submits an NCC check and gets a continue url for the applicant
 * @param {SubmitNccCheckRequest} req request with dasher applicant unique link
 * @returns A promise with NCC continue url
 *
 * Error codes:
 * 400: Bad request when applicant unique link empty/invalid
 * 500: Internal server error
 */
export const submitNccCheck = async (
  req: SubmitNccCheckRequest
): Promise<SubmitNccCheckResponse> => {
  try {
    const response = await axios.post(
      'v1/ncc/check',
      snakeCaseObjectKeys(req),
      bffOpts
    )

    return camelCaseObjectKeys(response.data)
  } catch (error) {
    let errorResponse
    if (error.response) {
      const { status, data } = error.response
      errorResponse = `${status} ${data}`
    } else {
      errorResponse = error.message
    }

    throw errorResponse
  }
}
